import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Scheduler from './Scheduler';
import Editor from './Editor';
import { flexcol, flexrow, noSpacing } from '../../global';
import { Footer } from './Footer';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-booking-tabpanel-${index}`}
      aria-labelledby={`admin-booking-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{...noSpacing,  pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `admin-booking-tab-${index}`,
    'aria-controls': `admin-booking-tabpanel-${index}`,
  };
}

export default function AdminBooking() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(location.pathname === '/admin/booking/editor' ? 1 : 0);

  // Sync tab with path when navigating (e.g. direct URL, browser back/forward)
  useEffect(() => {
    const isEditor = location.pathname === '/admin/booking/editor';
    setTabValue(isEditor ? 1 : 0);
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    // Update URL when tab changes
    navigate(newValue === 0 ? '/admin/booking/scheduler' : '/admin/booking/editor');
  };

  return (
    <Box style={{...flexcol}}>
      <Box>
        <Typography variant="h1">
          Admin Scheduling
        </Typography>
      
        <Box sx={{ display: 'inline-block' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Scheduler" {...a11yProps(0)} />
            <Tab label="Editor" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <Scheduler />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Editor />
        </TabPanel>
      </Box>
    </Box>
  );
}